// utils/formatPhoneNumber.js
export function formatPhoneNumber(value) {
  // Eliminar todos los caracteres que no sean números
  const phoneNumber = value.replace(/\D/g, '');

  // Si el usuario está borrando, devolver el valor directamente para que sea editable
  if (phoneNumber.length === 0) return '';

  // Validar que el número tenga entre 8 y 11 dígitos
  if (phoneNumber.length < 8) {
    // Si tiene menos de 8 dígitos, permitir seguir escribiendo
    return phoneNumber;
  }

  // Si tiene más de 11 dígitos, truncar a 11
  if (phoneNumber.length > 11) {
    return phoneNumber.slice(0, 11);
  }

  // Formatear el número según su longitud
  if (phoneNumber.length <= 3) {
    // Para los primeros 3 dígitos, mostrar sin formato
    return phoneNumber;
  } else if (phoneNumber.length <= 6) {
    // Para 4-6 dígitos, formato (XXX) XXX
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  } else {
    // Para 7-11 dígitos, formato (XXX) XXX-XXXX
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }
}
